<template>
  <div v-scroll="scrolled">
    <!--Start shopping cart-->
    <div class="text-center">
      <!-- persistent: a fullscreen dialog has no overlay, so a click on any
           swal popup counts as a click outside and would close the cart -->
      <v-dialog
        v-model="visible"
        width="100%"
        fullscreen
        scrollable
        persistent
        no-click-animation
        transition="dialog-bottom-transition"
      >
        <template v-slot:activator="{ on, attrs }">
          <!--Start Menu Page Basket button-->
          <v-btn
            id="showBtn"
            width="100%"
            height="65px"
            :color="can_change_color ? 'primary' : 'accent'"
            class="text-capitalize mb-5"
            dark
            v-bind="attrs"
            v-on="on"
            style="
              border-top-right-radius: 40px;
              border-top-left-radius: 40px;
              position: fixed;
              bottom: 0%;
              right: 0%;
              left: 0%;
              z-index: 4;
            "
          >
            <!--todo:HI please remove style attr and use class or id to apply this style -->
            <div class="d-flex justify-center">
              <div>
                <v-badge
                  :content="NProductSelect"
                  :value="NProductSelect"
                  color="primary"
                  overlap
                  bottom
                >
                  <v-icon class="mt-0" size="32px" color="white" dark>
                    mdi-purse
                  </v-icon>
                </v-badge>
              </div>

              <div>
                <h5
                  class="font-weight-regular font-size-sm white--text pl-4 pt-1"
                >
                  {{ $t("generic.lang_shoppingCart") }} (<total-wrapper
                    :total="total"
                  ></total-wrapper
                  >)
                </h5>
              </div>
            </div>
          </v-btn>
          <!--End Menu Page Basket button-->
        </template>

        <!--Start Shopping Cart Content-->
        <v-card color="bg">
          <v-card-title class="pa-0 border-bottom pb-0">
            <v-toolbar elevation="0" class="py-3 px-2 transparent">
              <v-toolbar-items class="d-flex">
                <div>
                  <v-toolbar-title
                    class="font-weight-medium font-size-sm pr-2 primary--text text-h6"
                  >
                    {{ $t("generic.lang_shoppingCart") }}
                  </v-toolbar-title>
                </div>

                <div>
                  <v-badge
                    :content="NProductSelect"
                    :value="NProductSelect"
                    color="accent"
                    overlap
                    bottom
                    bordered
                  >
                    <v-icon color="primary" size="27px">
                      mdi-purse-outline
                    </v-icon>
                  </v-badge>
                </div>
              </v-toolbar-items>

              <v-spacer></v-spacer>

              <v-btn
                class="pb-6"
                x-large
                color="primary"
                icon
                dark
                @click="visible = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
          </v-card-title>

          <v-card-text class="mx-0 px-2 pt-5">
            <div class="mx-1">
              <h5 class="font-weight-bolder pb-0">
                {{ $t("generic.lang_yourSelection") }}
              </h5>
              <div class="d-flex align-middle align-center">
                <v-icon> mdi-information-outline </v-icon>
                <span class="ml-2">
                  {{ this.$t("generic.lang_swipe_right_to_remove") }}
                </span>
              </div>
            </div>

            <!--Start Shopping Cart Orders-->
            <div class="mx-1">
              <shopping-cart-orders-card />
            </div>
            <!--End Shopping Cart Orders-->

            <promo-code-row v-if="!isCardEmpty" />

            <!--start order note-->
            <!--            <div class="mx-1">
                          <v-textarea
                            v-model="order_note"
                            height="80"
                            dense
                            outlined
                            prepend-inner-icon="mdi-comment"
                            :label="$t('generic.lang_typeOrderNote')"
                          />
                        </div>-->
            <!--end order note-->

            <div class="px-6 mt-3 pb-2 mx-auto text-center">
              <div class="d-flex">
                <h5 class="font-weight-bold primary--text">
                  {{ $t("generic.lang_total") }}
                </h5>
                <v-spacer></v-spacer>
                <h5 class="font-weight-bold primary--text">
                  <total-wrapper :total="this.total"></total-wrapper>
                </h5>
              </div>
              <!-- commented for now
              <p class="mt-4 small grey--text">
                {{ $t("generic.lang_takeAwayOrderText") }}
              </p>
              -->
            </div>

            <!--order note / message-->
            <!--            <div class="px-5 text-center mt-3">
                          <strong class="text-center ">
                            Please wait until all guests at your table have selected. The order is then bundled and sent to the
                            kitchen for everyone.
                          </strong>
                        </div>-->
            <v-sheet height="200px" color="transparent" />
          </v-card-text>
          <!--Start dialog Basket button-->
          <v-card-actions>
            <v-btn
              v-if="
                !enableAllYouCanEatMode ||
                  isAycePerGroupMode ||
                  timeForNextOrder === '00:00'
              "
              @click="redirectToCheckout()"
              :disabled="
                loading ||
                  isCardEmpty ||
                  (isAycePerGroupMode && cartHasLockedGroupItems)
              "
              :loading="loading"
              width="100%"
              height="65px"
              color="accent"
              dark
              class="text-capitalize"
              style="
                border-top-right-radius: 40px;
                border-top-left-radius: 40px;
                position: fixed;
                bottom: 0%;
                right: 0%;
                left: 0%;
              "
            >
              <div class="d-flex justify-center">
                <h4 class="font-weight-regular white--text pt-1 pr-2">
                  {{ $t("generic.lang_order_for_my_table") }}
                </h4>

                <v-icon size="26px" color="white" dark>
                  mdi-arrow-right
                </v-icon>
              </div>
            </v-btn>
            <!-- Mode B: locked items warning shown below the button -->
            <div
              v-if="isAycePerGroupMode && cartHasLockedGroupItems"
              class="pa-2 text-center caption error--text"
            >
              {{ $t("generic.lang_cartHasLockedGroupItems") }}
            </div>
            <!-- Mode A: global timer shown instead of button -->
            <h5
              v-else-if="
                enableAllYouCanEatMode &&
                  !isAycePerGroupMode &&
                  timeForNextOrder !== '00:00'
              "
              class="mx-auto"
            >
              {{ $t("generic.lang_nextOrderIn") }}: {{ timeForNextOrder }}
            </h5>
          </v-card-actions>
          <!--End Dialog Basket button-->
        </v-card>
        <!--End Shopping Cart Content-->
      </v-dialog>
    </div>
    <!--End shopping cart-->

    <!-- No Payment Methods Dialog -->
    <v-dialog
      v-model="noPaymentsDialog"
      persistent
      max-width="400"
      style="z-index: 10"
    >
      <v-card>
        <v-card-title class="pa-1">
          <v-spacer></v-spacer>
          <v-btn icon @click="noPaymentsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="headline black--text text-center mt-3">
          {{ $t("generic.lang_noPaymentMethodsActivePleaseContactServer") }}
        </v-card-text>

        <v-card-actions>
          <v-btn
            @click="callWaiter"
            :disabled="calling_waiter"
            :loading="calling_waiter"
            class="mb-3 mx-auto"
            rounded
            color="primary"
          >
            {{ this.$t("generic.lang_call_waiter") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/*import components*/
import shoppingCartOrdersCard from "@/components/Card/shoppingCartOrdersCard";
import TotalWrapper from "@/components/Widget/TotalWrapper.vue";
import PromoCodeRow from "@/components/Card/PromoCodeRow";

/*import plugins*/
import { createNamespacedHelpers } from "vuex";
import ENDPOINTS from "@/plugins/axios/endpoints";
import { cartForOrder } from "@/utils/promoCode";

export default {
  components: { shoppingCartOrdersCard, TotalWrapper, PromoCodeRow },

  methods: {
    ...createNamespacedHelpers("Order").mapMutations(["waitApprove"]),
    //Redirect To Checkout Page
    redirectToCheckout() {
      if (this.payments.length === 0) {
        this.noPaymentsDialog = true;
      } else {
        if (
          this.enableAllYouCanEatMode &&
          this.enableAllYouCanEatModeSettings.skipPaymentScreen
        ) {
          this.processOrderWithSkipPaymentScreen();
        } else {
          this.$router.push({ name: "Checkout" });
        }
      }
    },
    scrolled() {
      this.isFixedBottom = document.getElementById("showBtn").offsetTop;
      /*          (window.pageYOffset || document.documentElement.scrollTop);*/
    },
    processOrderWithSkipPaymentScreen() {
      this.loading = true;

      // Set payment type to pay at checkout (no payment gateway needed)
      this.payment_type = "tablebee_pay_at_checkout_active";

      const body = this.createPaymentRequestBody();

      this.$axios
        .post(ENDPOINTS.SELF_SERVICE.ORDERS.CREATE, body)
        .then(res => {
          // capture card items before they are cleared, needed for per-group timers
          const orderedItems = [...(this.card || [])];

          this.$store.commit("Order/setGiftCard", undefined);
          //if ordering as group is enabled we have to indicate that this order is waiting to mark it as last order
          this.waitApprove(this.can_order_as_group);

          if (this.payment_type === "tablebee_pay_at_checkout_active") {
            this.$store.commit("Order/setUnpaidOrder", res.data.order_id);
            this.$store.commit("Order/clearCard");
            this.$router.push(`success/${res.data.order_id}?type=unpaid`);
            this.$forceUpdate();
          }

          // start the appropriate timer after a successful order
          if (this.isAycePerGroupMode) {
            // Mode B: start per-group cooldown timers only for ordered groups
            this.$store.dispatch("Config/startGroupTimersForOrder", {
              orderedItems
            });
          } else {
            // Mode A: restart the global between-orders countdown
            this.$store.commit("Config/setTimeForNextOrder");
          }
        })
        .catch(err => {
          // check if the error is from the backend
          if (
            err.response &&
            err.response?.data &&
            err.response.data?.message
          ) {
            this.$swal({
              title: this.$t("errors.lang_cant_create_order"),
              text: err.response.data.message,
              icon: "error"
            });
          } else {
            this.$swal({
              title: this.$t("errors.lang_cant_create_order"),
              text: this.$t("errors.lang_try_again"),
              icon: "error"
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    createPaymentRequestBody() {
      const openItems = cartForOrder(this.card);

      //prepare order request body
      let body = {
        table: {
          name: this.table,
          party: this.party,
          uuid: this.uuid
        },
        note: this.note,
        customer_id: null,
        openItems,
        items: this.ordered || [],
        giftCard: this.giftCard,
        payment_id: this.payment_type,
        ignorePayment: this.payment_type === "tablebee_pay_at_checkout_active"
      };

      //add customer info
      if (this.tb_enableSMSSending) {
        body.phoneNumber = this.phoneNumber;
      }

      //attach the old order id to the request to ensure that we'll update it
      if (this.order && this.order.id !== undefined)
        body.order_id = this.order.id;

      return body;
    },
    callWaiter() {
      this.calling_waiter = true;
      this.$axios
        .post(window.ENDPOINTS.SELF_SERVICE.NOTIFY, {
          table: {
            uuid: this.uuid,
            name: this.table,
            party: this.party
          },
          type: 1,
          message: "",
          paymentType: null
        })
        .then(res => {
          if (res.data.success === true)
            this.$swal({
              title: this.$t("generic.lang_success"),
              text: this.$t("generic.lang_waiter_will_join_you"),
              icon: "success"
            });
        })
        .catch(() => {
          this.$swal({
            title: this.$t("errors.lang_try_again"),
            text: this.$t("generic.lang_cant_call_waiter"),
            icon: "error"
          });
        })
        .finally(() => {
          this.calling_waiter = false;
        });
    }
  },

  props: {
    orders: []
  },
  watch: {
    total(val) {
      if (val) {
        this.can_change_color = true;
        const self = this;
        let timer = setTimeout(() => {
          self.can_change_color = false;
          clearTimeout(timer);
        }, 250);
      }
    }
  },
  computed: {
    ...createNamespacedHelpers("Order").mapGetters([
      "isCardEmpty",
      "card",
      "total",
      "note",
      "ordered",
      "giftCard",
      "order"
    ]),
    ...createNamespacedHelpers("Table").mapGetters([
      "table",
      "party",
      "uuid",
      "phoneNumber"
    ]),
    ...createNamespacedHelpers("Config").mapGetters([
      "tb_enableSMSSending",
      "can_order_as_group",
      "enableAllYouCanEatMode",
      "enableAllYouCanEatModeSettings",
      "timeForNextOrder",
      "payments",
      "isAycePerGroupMode",
      "ayceLockedGroupIds"
    ]),
    fromBottom() {
      return /*window.pageYOffset || */ document.documentElement.scrollTop;
    },
    /*get number of selected items*/
    NProductSelect() {
      return this.card.reduce((total, item) => total + (item.quantity || 0), 0);
    },
    // true when Mode B is active and the cart contains items from a currently locked group
    cartHasLockedGroupItems() {
      if (!this.isAycePerGroupMode) return false;
      return this.card.some(entry =>
        this.ayceLockedGroupIds.includes(Number(entry.item?.category_id))
      );
    },

    /*order note accessors*/
    order_note: {
      get() {
        return this.note;
      },
      set(val) {
        this.$store.commit("Order/setOrderNote", val);
      }
    }
  },
  data() {
    return {
      //to change color when we add  a new item
      can_change_color: false,
      visible: false,
      isFixedBottom: true,
      payment_type: null,
      loading: false,
      noPaymentsDialog: false,
      calling_waiter: false
    };
  }
};
</script>
